import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-location',
  templateUrl: './show-location.component.html',
  styleUrls: ['./show-location.component.scss'],
})
export class ShowLocationComponent implements OnInit {
  location = '';

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.doc$('master/masterInfo').pipe(take(1)).toPromise();
    this.location = admin.termsInfo.location;
  }
}
